import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import CustomData from "pages/_components/CustomData/CustomData";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { actions as creditBillActions } from "reducers/creditBills";
import { formatAction } from "util/creditBills";
import * as i18n from "util/i18n";
import BillInfoSummary from "../components/BillsInfoSummary";
import ActionBillTable from "../components/Table";

const ActionFCEMSummaryPage = ({ isDesktop }) => {
    const { actionData, actionTicket } = useSelector((state) => state.creditBills);
    const { actionInLowerCase, actionI18n } = formatAction(actionData?.action);
    const action = useRef(actionInLowerCase);
    const hasMoreThan1Bill = actionData?.invoiceList?.length > 1;
    const showMotive = !!actionData?.motive;

    useConfirmTransaction(actionData, actionTicket, `creditBills/${action.current}`);

    return (
        <>
            <Notification scopeToShow="transmitFCEMSummaryPage" />
            <ResponsiveHeader id={`creditBill.${actionI18n}`} showLabel />
            <MainContainer className="credit-bills">
                <div className="container">
                    <h2>{i18n.get("afip.payment.confirm")}</h2>
                    {showMotive && (
                        <div className="box box-border-soft soft-inform-control">
                            <GridTable>
                                <GridTable.Container columns={isDesktop ? 3 : 1}>
                                    <GridTable.Data columnStart={1}>
                                        <CustomData
                                            titleText={`creditBill.${actionI18n}.motive.label`}
                                            titleTextType="I18N"
                                            valueText={actionData.motive}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </div>
                    )}
                    {hasMoreThan1Bill && (
                        <BillInfoSummary bills={actionData?.invoiceList} isSummaryPage isDesktop={isDesktop} />
                    )}
                    <ActionBillTable
                        isDesktop={isDesktop}
                        tabOption={actionData.tabOption}
                        bills={actionData.invoiceList}
                        summary
                        hideButton
                    />
                    <GeneralCredentialForm
                        transactionData={actionData}
                        action={creditBillActions.transmitBill}
                        idActivity="fcem.action"
                        signData={["action"]}
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

ActionFCEMSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ActionFCEMSummaryPage;
